/*
 * Module for the epc mapping modal, which is basically just the contentMappingModal module
 * but slightly modified for use with epc codes.  May consider trying to merge in the future.
 */

define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "modules/shared/epcMappingModal/epcMappingModalView",
  "modules/shared/navTree/navTreeModule",
  "modules/shared/selectableList/selectableListModule",
], function (Marionette, $, Messenger, EpcMappingModalView, NavTreeModule, SelectableListModule) {
  var EpcMappingModalController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "epcMappingModal";
      this.region = options.region;
      this.selectedCode = null;
      this.model = options.model; //pass model to update
      this.attribute = options.attribute; //pass attribute to update
      this._setUpVents();
    },
    show: function (root) {
      this.layout = new EpcMappingModalView.epcMappingModalLayout();
      this.layout.on(
        "done",
        function () {
          if (this.selectedCode !== null) {
            this.model.set(this.attribute, this.selectedCode.get("code"));
            Messenger.vent.trigger("close:modal");
          } else {
            //no code selected, so show an error
            this.epcError($.t("topic.epc.noCodeError"));
          }
        },
        this,
      );
      this.layout.on(
        "cancel",
        function () {
          Messenger.vent.trigger("close:modal");
        },
        this,
      );
      this.layout.on(
        "show",
        function () {
          this._showSubViews(root);
        },
        this,
      );
      this.tree = this.addSubModule(
        new NavTreeModule({
          region: this.layout.navTree,
          nameAttribute: "name",
          namespace: "epcMapping",
        }),
      );
      this.list = this.addSubModule(new SelectableListModule({ region: this.layout.navList }));
      this.showRegion(this.layout);
    },
    clearError: function () {
      this.layout.clearError();
    },
    epcError: function (errorMessage) {
      this.layout.epcError(errorMessage);
    },
    _showSubViews: function (rootEpcGroup) {
      this.tree.show(rootEpcGroup);
    },
    _setUpVents: function () {
      //handle when we select a code
      Messenger.vent.on(
        "list:item:selected",
        function (model) {
          this.selectedCode = model;
        },
        this,
      );

      Messenger.vent.on(
        "epcMapping:select:group",
        function (groupView) {
          console.log("epc group select!");
          this.list.show(groupView.model.subCategories());
        },
        this,
      );
    },
  });

  return EpcMappingModalController;
});
